import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity, StatusBar, TextInput, Platform } from 'react-native'
import theme from '../../../theme'
import styles from './BottomSheetAlertStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'

export const BottomSheetAlert = ({ image, title, desc, button, closeBottomSheet, buttonGoto = null, goto = null }) => {
    return (
        <>
            <View style={styles.contentContainer}>
                <View style={styles.messageContainer}>
                    <View>
                        {image && image != '' && (
                            <Image
                                style={[
                                    styles.imageAsset,
                                    {
                                        marginTop: buttonGoto ? -48 : 0,
                                        borderRadius: desc === 'Al eliminar el usuario, deberás volver a ingresarlo manualmente a la lista.' ? 60 : 0,
                                    },
                                ]}
                                source={image}
                                resizeMode='contain'
                            />
                        )}
                    </View>

                    <Text style={styles.titleText}>{title}</Text>

                    <Text style={styles.descriptionText}>{desc}</Text>
                </View>
                <View style={[styles.buttonContainer2]}>
                    {buttonGoto && (
                        <TouchableOpacity style={[styles.mainButton]} onPress={() => goto()}>
                            <Text style={styles.mainButtonText}>{buttonGoto}</Text>
                        </TouchableOpacity>
                    )}
                    {button && Platform.OS !== 'web' && (
                        <TouchableOpacity style={[styles.borderButton]} onPress={() => closeBottomSheet(true)}>
                            <Text style={styles.borderButtonText}>{button}</Text>
                        </TouchableOpacity>
                    )}
                    {button && Platform.OS === 'web' && (
                        <TouchableOpacity style={[styles.borderButton]} onPress={closeBottomSheet}>
                            <Text style={styles.borderButtonText}>{button}</Text>
                        </TouchableOpacity>
                    )}
                </View>
            </View>
        </>
    )
}

export const FullSheetAlert = ({ image, title, desc, button, closeBottomSheet, buttonGoto = null, goto = null }) => {
    return (
        <View style={styles.contentContainer}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={[styles.messageContainer]}>
                <View>
                    {image && image != '' && (
                        <Image style={[styles.imageAssetFullSheet, { marginTop: buttonGoto ? 0 : 0 }]} source={image} resizeMode='contain' />
                    )}
                </View>

                <Text style={styles.titleTextFullSheet}>{title}</Text>

                <Text style={[styles.descriptionTextFullSheet]}>{desc}</Text>
            </View>
            <View style={[styles.buttonContainer2, Platform.OS == 'ios' && { marginBottom: 15 }]}>
                {buttonGoto && (
                    <TouchableOpacity style={[styles.mainButton]} onPress={() => goto()}>
                        <Text style={styles.mainButtonText}>{buttonGoto}</Text>
                    </TouchableOpacity>
                )}
                {button && (
                    <TouchableOpacity style={[styles.borderButton]} onPress={() => closeBottomSheet(true)}>
                        <Text style={styles.borderButtonText}>{button}</Text>
                    </TouchableOpacity>
                )}
            </View>
        </View>
    )
}

export const BottomSheetBackAlert = ({ closeBottomSheet }) => {
    const { languageFile } = getLanguage()

    return (
        <View style={styles.contentContainer}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.messageContainer}>
                <View>
                    <Image style={styles.imageAsset} source={require('../../../assets/evaluations/evaluationGoOut.png')} resizeMode='contain' />
                </View>

                <Text style={styles.titleText}>{languageFile.exit_evaluation}</Text>

                <Text style={styles.descriptionText}>{languageFile.your_answers_will_not_be_saved}</Text>
            </View>
            <View style={styles.spacer}></View>
            <View style={styles.buttonContainer}>
                <TouchableOpacity style={[styles.mainButton]} onPress={() => closeBottomSheet(false)}>
                    <Text style={styles.mainButtonText}>{languageFile.continue_evaluation}</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.goOutBlock}>
                    <Text style={styles.goOutText}>{languageFile.leave_anyway}</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}

export const BottomSheetAlertWithInput = ({ image, title, desc, accept, closeBottomSheet }) => {
    const [text, setText] = useState('')
    const { languageFile } = getLanguage()

    return (
        <>
            <View style={styles.contentContainer}>
                {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                <View style={styles.messageContainer}>
                    <View>
                        <Image style={styles.imageAsset} source={require('../../../assets/accountPitch.png')} resizeMode='contain' />
                    </View>

                    <Text style={styles.titleText}>{title}</Text>

                    <Text style={styles.descriptionTextBis}>{desc}</Text>

                    <Text style={styles.subtitleText}>Agregar comentarios (opcional)</Text>

                    <View style={styles.inputBlock}>
                        <TextInput
                            onChangeText={(text) => setText(text)}
                            value={text}
                            style={styles.input}
                            placeholder='Ingresa un comentario...'
                            placeholderTextColor={theme.colors.mediumGray}
                            multiline={true}
                        />
                    </View>
                </View>

                <View style={styles.buttonContainer2}>
                    {accept && (
                        <TouchableOpacity style={[styles.mainButton]} onPress={() => accept()}>
                            <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                        </TouchableOpacity>
                    )}

                    <TouchableOpacity style={[styles.borderButton]} onPress={() => closeBottomSheet(true)}>
                        <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}
